export const GET_ARTICLE='GET_ARTICLE'